import React from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "../../../stylesheets/components/Reports/HoldingReports/StockDetails.scss";
var GenericSidebar = function (props) {
    var hideDetailSection = function (e) {
        var currNode = e.currentTarget.parentNode.parentNode.parentNode;
        currNode.classList.add("hideDetailSection");
        setTimeout(function () {
            if (props === null || props === void 0 ? void 0 : props.closebtn) {
                props.onBackFn(false);
            }
            else {
                props.setOpenKey(false);
            }
        }, 2000);
    };
    return (React.createElement(SlidingPane, { hideHeader: true, overlayClassName: "generic-sidebar-overlayblock \n        ".concat(props.blurBackground ? " blur-background " : " no-blur ", "\n        ").concat(props.overlayClassName ? props.overlayClassName : ""), className: "Marketstock-details-block", isOpen: props.openKey, from: "right", onRequestClose: function () {
            document
                .getElementsByClassName("stock-details")[0]
                .classList.add("hideDetailSection");
            setTimeout(function () {
                props.setOpenKey(false);
            }, 700);
        } },
        React.createElement("div", { className: "stock-details ".concat(props.parentClassname ? props.parentClassname : "") },
            props.header && (React.createElement("div", { className: "stock-details-head" },
                props.arrowClose && (React.createElement("div", { className: "stock-details-switch-key", onClick: function (e) { return hideDetailSection(e); } }, props.customArrow ? (props.customArrow) : (React.createElement("i", { className: "edel-icon-arrow-right1" })))),
                props.header)),
            props.body && React.createElement("div", { className: "stock-details-body" }, props.body),
            props.footer && (React.createElement("div", { className: "stock-details-footer" }, props.footer)))));
};
export default GenericSidebar;
